import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import login from '@/components/login'
import template from '@/components/template'
import defaultview from '@/components/default'

import authority from '@/components/adminmanage/authority'
import mgruser from '@/components/adminmanage/mgruser'
import userloginrecord from '@/components/adminmanage/userloginrecord'
import viprankslot from '@/components/slotleaderboard/viprank'
import termsetslot from '@/components/slotleaderboard/termset'
import userbetslot from '@/components/slotleaderboard/userbet'
import usertotalslot from '@/components/slotleaderboard/usertotal'
import importdataslot from '@/components/slotleaderboard/importdata'
import vipranklive from '@/components/liveleaderboard/viprank'
import termsetlive from '@/components/liveleaderboard/termset'
import userbetlive from '@/components/liveleaderboard/userbet'
import usertotallive from '@/components/liveleaderboard/usertotal'
import importdatalive from '@/components/liveleaderboard/importdata'
import borroworder from '@/components/ordermanage/borroworder'
import repayorder from '@/components/ordermanage/repayorder'
import orderhistory from '@/components/ordermanage/orderhistory'
import usermanage from '@/components/usermanage/usermanage'
import creditadvance from '@/components/usermanage/creditadvance'
import userimport from '@/components/usermanage/userimport'
import upgradedomain from '@/components/receptionset/upgradedomain'
import message from '@/components/receptionset/message'
import progress from '@/components/userbetmanager/progress'
import safemanager from '@/components/receptionset/safemanager'
import createactivie from '@/components/promotions/createactivie'
import activielist from '@/components/promotions/activielist'
import formconfiguration from '@/components/promotions/formconfiguration'
import activieapply from '@/components/promotions/activieapply'
import saleuserlist from '@/components/accounttransaction/saleuserlist'
import salelist from '@/components/accounttransaction/salelist'
import principaltermset from '@/components/principal/principaltermset'
import principalrank from '@/components/principal/principalrank'
import statistics from '@/components/principal/statistics'

/*--USDT排行榜--*/
//会员等级(USDT)
import viprankusdt from '@/components/usdtleaderboard/viprank'
//周期分类(USDT)
import termsetusdt from '@/components/usdtleaderboard/termset'
//存款导入(USDT)
import userbetusdt from '@/components/usdtleaderboard/userbet'
//会员存款(USDT)
import usertotalusdt from '@/components/usdtleaderboard/usertotal'
//会员统计(USDT)
import importdatausdt from '@/components/usdtleaderboard/importdata'

/* --账号交易 --*/
//会员管理
import accountuser from '@/components/accounttransaction/accountuser'
//账号评估管理
import accountevaluation from '@/components/accounttransaction/accountevaluation'
//账号回收管理
import accountrecovery from '@/components/accounttransaction/accountrecovery'
//真人等级回收
import liverankreclaim from '@/components/accounttransaction/liverankreclaim'
//电子等级回收
import slotrankreclaim from '@/components/accounttransaction/slotrankreclaim'

/* --电子竞技榜 --*/
//电子排行分类
import classification from '@/components/slotpvp/classification'
//电子排行
import leaderboard from '@/components/slotpvp/leaderboard'

//借还款调整记录
import paymentrecord from '@/components/ordermanage/paymentrecord'

//已绑定Google验证器
import googleverify from '@/components/googleverify'

//代理活动
import agentpromotionset from '@/components/agentpromotion/agentpromotionset'
import agentpromotionuser from '@/components/agentpromotion/agentpromotionuser'
import agentpromotiondetail from '@/components/agentpromotion/agentpromotiondetail'

/*--会员VIP--*/
//VIP等级
import viprankuservip from '@/components/vipleaderboard/viprankuservip'
//周期分类
import termsetvip from '@/components/vipleaderboard/termsetvip'
//VIP投注导入
import importdatavip from '@/components/vipleaderboard/importdatavip'
//VIP投注
import userbetvip from '@/components/vipleaderboard/userbetvip'
//VIP统计
import usertotalvip from '@/components/vipleaderboard/usertotalvip'

//自助客服
import customerservicelist from '@/components/customerservice/customerservicelist'
import customerserviceinput from '@/components/customerservice/customerserviceinput'
import customerserviceapply from '@/components/customerservice/customerserviceapply'
import customerservicehistory from '@/components/customerservice/customerservicehistory'


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
      mode: 'history',
    },
    {
      path: '/template',
      name: 'template',
      component: template,
      mode: 'history',
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      mode: 'history',
      meta: {
        keepalive: true
      },
      children: [
        {
          path: "/default",
          name: "default",
          mode: "history",
          component: defaultview,
          meta: {
            breadcrumb: ["首页"],
            navbarKey: "0"
          }
        },
        {
          path: "/googleverify",
          name: "googleverify",
          mode: "history",
          component: googleverify,
          meta: {
            breadcrumb: ["谷歌验证"],
            navbarKey: "0"
          }
        }
        , {
          path: "/user",
          name: "user",
          mode: "history",
          component: usermanage,
          meta: {
            keepalive: true,
            breadcrumb: ["会员管理", "会员列表"],
            navbarKey: "1_6"
          }
        }
        , {
          path: "/creditadvance",
          name: "creditadvance",
          mode: "history",
          component: creditadvance,
          meta: {
            keepalive: true,
            breadcrumb: ["会员管理", "信用借支"],
            navbarKey: "1_66"
          }
        }
        , {
          path: "/userimport",
          name: "userimport",
          mode: "history",
          component: userimport,
          meta: {
            keepalive: true,
            breadcrumb: ["会员管理", "会员上传"],
            navbarKey: "1_67"
          }
        }
        , {
          path: "/borroworder",
          name: "borroworder",
          mode: "history",
          component: borroworder,
          meta: {
            keepalive: true,
            breadcrumb: ["订单管理", "借款订单"],
            navbarKey: "2_7"
          }
        }
        , {
          path: "/repayorder",
          name: "repayorder",
          mode: "history",
          component: repayorder,
          meta: {
            keepalive: true,
            breadcrumb: ["订单管理", "还款订单"],
            navbarKey: "2_62"
          }
        }
        , {
          path: "/orderhistory",
          name: "orderhistory",
          mode: "history",
          component: orderhistory,
          meta: {
            keepalive: true,
            breadcrumb: ["借呗订单管理", "历史订单数据"],
            navbarKey: "2_76"
          }
        }
        , {
          path: "/paymentrecord",
          name: "paymentrecord",
          mode: "history",
          component: paymentrecord,
          meta: {
            keepalive: true,
            breadcrumb: ["借呗订单管理", "借还款调整记录"],
            navbarKey: "2_219"
          }
        }
        , {
          path: "/authority",
          name: "authority",
          mode: "history",
          component: authority,
          meta: {
            keepalive: true,
            breadcrumb: ["管理员管理", "权限设定"],
            navbarKey: "3_11"
          }
        }
        , {
          path: "/mgruser",
          name: "mgruser",
          mode: "history",
          component: mgruser,
          meta: {
            keepalive: true,
            breadcrumb: ["管理员管理", "用户管理"],
            navbarKey: "3_58"
          }
        }
        , {
          path: "/userloginrecord",
          name: "userloginrecord",
          mode: "history",
          component: userloginrecord,
          meta: {
            keepalive: true,
            breadcrumb: ["管理员管理", "登入记录查询"],
            navbarKey: "3_71"
          }
        }
        , {
          path: "/viprankslot",
          name: "viprankslot",
          mode: "history",
          component: viprankslot,
          meta: {
            keepalive: true,
            breadcrumb: ["电子排行榜", "会员等级"],
            navbarKey: "4_15"
          }
        }
        , {
          path: "/termsetslot",
          name: "termsetslot",
          mode: "history",
          component: termsetslot,
          meta: {
            keepalive: true,
            breadcrumb: ["电子排行榜", "周期分类"],
            navbarKey: "4_19"
          }
        }
        , {
          path: "/importdataslot",
          name: "importdataslot",
          mode: "history",
          component: importdataslot,
          meta: {
            keepalive: true,
            breadcrumb: ["电子排行榜", "投注导入"],
            navbarKey: "4_23"
          }
        }
        , {
          path: "/userbetslot",
          name: "userbetslot",
          mode: "history",
          component: userbetslot,
          meta: {
            keepalive: true,
            breadcrumb: ["电子排行榜", "会员投注"],
            navbarKey: "4_27"
          }
        }
        , {
          path: "/usertotalslot",
          name: "usertotalslot",
          mode: "history",
          component: usertotalslot,
          meta: {
            keepalive: true,
            breadcrumb: ["电子排行榜", "会员统计"],
            navbarKey: "4_31"
          }
        }
        , {
          path: "/vipranklive",
          name: "vipranklive",
          mode: "history",
          component: vipranklive,
          meta: {
            keepalive: true,
            breadcrumb: ["真人排行榜", "会员等级"],
            navbarKey: "5_35"
          }
        }
        , {
          path: "/termsetlive",
          name: "termsetlive",
          mode: "history",
          component: termsetlive,
          meta: {
            keepalive: true,
            breadcrumb: ["真人排行榜", "周期分类"],
            navbarKey: "5_39"
          }
        }
        , {
          path: "/importdatalive",
          name: "importdatalive",
          mode: "history",
          component: importdatalive,
          meta: {
            keepalive: true,
            breadcrumb: ["真人排行榜", "投注导入"],
            navbarKey: "5_43"
          }
        }
        , {
          path: "/userbetlive",
          name: "userbetlive",
          mode: "history",
          component: userbetlive,
          meta: {
            keepalive: true,
            breadcrumb: ["真人排行榜", "会员投注"],
            navbarKey: "5_47"
          }
        }
        , {
          path: "/usertotallive",
          name: "usertotallive",
          mode: "history",
          component: usertotallive,
          meta: {
            keepalive: true,
            breadcrumb: ["真人排行榜", "会员统计"],
            navbarKey: "5_51"
          }
        }
        , {
          path: "/upgrade",
          name: "upgrade",
          mode: "history",
          component: upgradedomain,
          meta: {
            keepalive: true,
            breadcrumb: ["前台设置", "升级域名"],
            navbarKey: "72_73"
          }
        }
        , {
          path: "/message",
          name: "message",
          mode: "history",
          component: message,
          meta: {
            keepalive: true,
            breadcrumb: ["前台设置", "公告管理"],
            navbarKey: "72_115"
          }
        }
        , {
          path: "/safemanager",
          name: "safemanager",
          mode: "history",
          component: safemanager,
          meta: {
            keepalive: true,
            breadcrumb: ["前台设置", "安全管理"],
            navbarKey: "72_121"
          }
        }
        , {
          path: "/progress",
          name: "progress",
          mode: "history",
          component: progress,
          meta: {
            keepalive: true,
            breadcrumb: ["会员投注管理", "会员计算进度查询"],
            navbarKey: "74_75"
          }
        }
        , {
          path: "/createactivie",
          name: "createactivie",
          mode: "history",
          component: createactivie,
          meta: {
            keepalive: true,
            breadcrumb: ["优惠活动大厅", "创建优惠活动"],
            navbarKey: "122_123"
          }
        }
        , {
          path: "/formconfiguration",
          name: "formconfiguration",
          mode: "history",
          component: formconfiguration,
          meta: {
            keepalive: true,
            breadcrumb: ["优惠活动大厅", "创建优惠活动"],
            navbarKey: "122_125"
          }
        }
        , {
          path: "/activielist",
          name: "activielist",
          mode: "history",
          component: activielist,
          meta: {
            keepalive: true,
            breadcrumb: ["优惠活动大厅", "优惠活动列表"],
            navbarKey: "122_124"
          }
        }
        , {
          path: "/activieapply",
          name: "activieapply",
          mode: "history",
          component: activieapply,
          meta: {
            keepalive: true,
            breadcrumb: ["优惠活动大厅", "活动申请记录"],
            navbarKey: "122_128"
          }
        }
        , {
          path: "/accountuser",
          name: "accountuser",
          mode: "history",
          component: accountuser,
          meta: {
            keepalive: true,
            breadcrumb: ["账号交易", "账号管理"],
            navbarKey: "131_132"
          }
        }
        , {
          path: "/accountevaluation",
          name: "accountevaluation",
          mode: "history",
          component: accountevaluation,
          meta: {
            keepalive: true,
            breadcrumb: ["账号交易", "账号评估管理"],
            navbarKey: "131_133"
          }
        }
        , {
          path: "/accountrecovery",
          name: "accountrecovery",
          mode: "history",
          component: accountrecovery,
          meta: {
            keepalive: true,
            breadcrumb: ["账号交易", "账号回收管理"],
            navbarKey: "131_134"
          }
        }
        , {
          path: "/liverankreclaim",
          name: "liverankreclaim",
          mode: "history",
          component: liverankreclaim,
          meta: {
            keepalive: true,
            breadcrumb: ["账号交易", "真人等级回收"],
            navbarKey: "131_135"
          }
        }
        , {
          path: "/slotrankreclaim",
          name: "slotrankreclaim",
          mode: "history",
          component: slotrankreclaim,
          meta: {
            keepalive: true,
            breadcrumb: ["账号交易", "电子等级回收"],
            navbarKey: "131_136"
          }
        }
        , {
          path: "/saleuserlist",
          name: "saleuserlist",
          mode: "history",
          component: saleuserlist,
          meta: {
            keepalive: true,
            breadcrumb: ["账号交易", "出售账号管理"],
            navbarKey: "131_130"
          }
        }
        , {
          path: "/salelist",
          name: "salelist",
          mode: "history",
          component: salelist,
          meta: {
            keepalive: true,
            breadcrumb: ["账号交易", "出价列表"],
            navbarKey: "131_137"
          }
        }
        , {
          path: "/classification",
          name: "classification",
          mode: "history",
          component: classification,
          meta: {
            keepalive: true,
            breadcrumb: ["电子竞技榜", "电子分类榜"],
            navbarKey: "138_139"
          }
        }
        , {
          path: "/leaderboard",
          name: "leaderboard",
          mode: "history",
          component: leaderboard,
          meta: {
            keepalive: true,
            breadcrumb: ["电子竞技榜", "电子排行榜"],
            navbarKey: "138_140"
          }
        }
        , {
          path: "/principaltermset",
          name: "principaltermset",
          mode: "history",
          component: principaltermset,
          meta: {
            keepalive: true,
            breadcrumb: ["翻本金", "分类管理"],
            navbarKey: "141_142"
          }
        }
        , {
          path: "/principalrank",
          name: "principalrank",
          mode: "history",
          component: principalrank,
          meta: {
            keepalive: true,
            breadcrumb: ["翻本金", "排行榜"],
            navbarKey: "141_143"
          }
        }
        , {
          path: "/statistics",
          name: "statistics",
          mode: "history",
          component: statistics,
          meta: {
            keepalive: true,
            breadcrumb: ["翻本金", "统计数据"],
            navbarKey: "141_199"
          }
        }
        , {
          path: "/viprankusdt",
          name: "viprankusdt",
          mode: "history",
          component: viprankusdt,
          meta: {
            keepalive: true,
            breadcrumb: ["USDT排行榜", "会员等级(USDT)"],
            navbarKey: "235_236"
          }
        }
        , {
          path: "/termsetusdt",
          name: "termsetusdt",
          mode: "history",
          component: termsetusdt,
          meta: {
            keepalive: true,
            breadcrumb: ["USDT排行榜", "周期分类(USDT)"],
            navbarKey: "235_237"
          }
        }
        , {
          path: "/importdatausdt",
          name: "importdatausdt",
          mode: "history",
          component: importdatausdt,
          meta: {
            keepalive: true,
            breadcrumb: ["USDT排行榜", "存款导入(USDT)"],
            navbarKey: "235_238"
          }
        }
        , {
          path: "/userbetusdt",
          name: "userbetusdt",
          mode: "history",
          component: userbetusdt,
          meta: {
            keepalive: true,
            breadcrumb: ["USDT排行榜", "会员存款(USDT)"],
            navbarKey: "235_239"
          }
        }
        , {
          path: "/usertotalusdt",
          name: "usertotalusdt",
          mode: "history",
          component: usertotalusdt,
          meta: {
            keepalive: true,
            breadcrumb: ["USDT排行榜", "会员统计(USDT)"],
            navbarKey: "235_240"
          }
        }
        , {
          path: "/agentpromotionset",
          name: "agentpromotionset",
          mode: "history",
          component: agentpromotionset,
          meta: {
            keepalive: true,
            breadcrumb: ["代理活动", "代理设置"],
            navbarKey: "0"
          }
        }
        , {
          path: "/agentpromotionuser",
          name: "agentpromotionuser",
          mode: "history",
          component: agentpromotionuser,
          meta: {
            keepalive: true,
            breadcrumb: ["代理活动", "代理列表"],
            navbarKey: "0"
          }
        }
        , {
          path: "/agentpromotiondetail",
          name: "agentpromotiondetail",
          mode: "history",
          component: agentpromotiondetail,
          meta: {
            keepalive: true,
            breadcrumb: ["代理活动", "佣金列表"],
            navbarKey: "0"
          }
        }
        , {
          path: "/viprankuservip",
          name: "viprankuservip",
          mode: "history",
          component: viprankuservip,
          meta: {
            keepalive: true,
            breadcrumb: ["会员VIP", "VIP等级"],
            navbarKey: "275_276"
          }
        }
        , {
          path: "/termsetvip",
          name: "termsetvip",
          mode: "history",
          component: termsetvip,
          meta: {
            keepalive: true,
            breadcrumb: ["会员VIP", "周期分类"],
            navbarKey: "275_277"
          }
        }
        , {
          path: "/importdatavip",
          name: "importdatavip",
          mode: "history",
          component: importdatavip,
          meta: {
            keepalive: true,
            breadcrumb: ["会员VIP", "VIP投注导入"],
            navbarKey: "275_278"
          }
        }
        , {
          path: "/userbetvip",
          name: "userbetvip",
          mode: "history",
          component: userbetvip,
          meta: {
            keepalive: true,
            breadcrumb: ["会员VIP", "VIP投注"],
            navbarKey: "275_279"
          }
        }
        , {
          path: "/usertotalvip",
          name: "usertotalvip",
          mode: "history",
          component: usertotalvip,
          meta: {
            keepalive: true,
            breadcrumb: ["会员VIP", "VIP统计"],
            navbarKey: "275_280"
          }
        }
        , {
          path: "/customerservicelist",
          name: "customerservicelist",
          mode: "history",
          component: customerservicelist,
          meta: {
            keepalive: true,
            breadcrumb: ["自助客服", "自助项目列表"],
            navbarKey: "299_300"
          }
        }
        , {
          path: "/customerserviceinput",
          name: "customerserviceinput",
          mode: "history",
          component: customerserviceinput,
          meta: {
            keepalive: true,
            breadcrumb: ["自助客服", "自助项目表单配置"],
            navbarKey: "299_300"
          }
        }
        , {
          path: "/customerserviceapply",
          name: "customerserviceapply",
          mode: "history",
          component: customerserviceapply,
          meta: {
            keepalive: true,
            breadcrumb: ["自助客服", "会员申请订单"],
            navbarKey: "299_301"
          }
        }
        , {
          path: "/customerservicehistory",
          name: "customerservicehistory",
          mode: "history",
          component: customerservicehistory,
          meta: {
            keepalive: true,
            breadcrumb: ["自助客服", "历史订单"],
            navbarKey: "299_302"
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path == "/login") {
    sessionStorage.clear();
    next();
  }
  else {
    if (sessionStorage.UserID) {
      if (to.path == "/") {
        next({ path: "/login" });
      }
      else {
        next();
      }
    }
    else {
      next({ path: "/login" });
    }
  }
})


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js